import helper from './helper'

const getAccountsUrlWithParameters = helper.getAccountsUrlWithParameters
// const getWorkerUrlWithParameters = helper.getWorkerUrlWithParameters
const getEducationUrlWithParameters = helper.getEducationUrlWithParameters

export default {
  CHOICES: {
    CONTACT_TYPE: (gets = null) => getAccountsUrlWithParameters(
      /**
       * Получает типы контактов
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения типов контактов
       */
      'choices|contacts|contact',
      'get',
      {},
      gets
    ),
    LANGUAGE_TYPE: (gets = null) => getAccountsUrlWithParameters(
      /**
       * Получает типы языков
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения типов языков
       */
      'choices|users|language',
      'get',
      {},
      gets
    ),
    ADVANCED_TRAINING_DOCUMENT_TYPE: (gets = null) => getEducationUrlWithParameters(
      /**
       * Получает типы документов для дополнительного образования
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения типов документов
       */
      'choices|relations|document|type',
      'get',
      {},
      gets
    ),
    ADVANCED_TRAINING_WORK_TYPE: (gets = null) => getEducationUrlWithParameters(
      /**
       * Получает типы работ для дополнительного образования
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения типов работ
       */
      'choices|relations|work|type',
      'get',
      {},
      gets
    ),
    ADVANCED_TRAINING_KNOWLEDGE_TYPE: (gets = null) => getEducationUrlWithParameters(
      /**
       * Получает направления знаний для дополнительного образования
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения направлений знаний
       */
      'choices|relations|knowledge|type',
      'get',
      {},
      gets
    )
  }
}
